import { createApp } from '@/services/createApp';
import formMetadata from '@/config/motortrade.json'; 

createApp("motortrade", { formMetadata, "productVersion":"v3","isLeadgen":true });